module.exports = __webpack_public_path__ + "img/product_50.79569c8.svg";